import { Draw } from '@Models';
import { EntityState, buildEntityState } from '../../EntityState';

export type DrawState = EntityState<Draw>;

export const buildDrawState = (data: Partial<DrawState> = {}) =>
  buildEntityState<Draw>(data);
